/** Client-side hints collected from the browser for posture detection. */

function _hash(str) {
  // Simple non-crypto hash (djb2 → hex 8 chars)
  let h = 5381;
  for (let i = 0; i < str.length; i++) h = ((h * 33) ^ str.charCodeAt(i)) >>> 0;
  return h.toString(16).padStart(8, "0");
}

function _uuid() {
  if (crypto.randomUUID) return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getOrCreateDeviceId() {
  let id = localStorage.getItem("dndi_device_id");
  if (!id) {
    id = _uuid();
    localStorage.setItem("dndi_device_id", id);
  }
  return id;
}

export function computeFingerprint() {
  const parts = [
    navigator.userAgent,
    navigator.language,
    (navigator.languages || []).join(","),
    navigator.platform,
    navigator.hardwareConcurrency || "",
    navigator.deviceMemory || "",
    `${window.screen.width}x${window.screen.height}x${window.screen.colorDepth}`,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    navigator.maxTouchPoints || "",
  ];
  return _hash(parts.join("|"));
}

export function requestGeolocation() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve({ permission: false, error: "unsupported" });
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({
        permission: true,
        lat: pos.coords.latitude,
        lon: pos.coords.longitude,
        accuracy: pos.coords.accuracy,
      }),
      (err) => resolve({ permission: false, error: err.message, code: err.code }),
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 }
    );
  });
}

export async function collectClientHints() {
  const hints = {
    secure_context: window.isSecureContext,
    tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
    cookies_enabled: navigator.cookieEnabled,
    hardware_concurrency: navigator.hardwareConcurrency,
    lang: navigator.language,
    screen: `${window.screen.width}x${window.screen.height}`,
    device_id: getOrCreateDeviceId(),
    fingerprint: computeFingerprint(),
  };
  try {
    if (navigator.userAgentData?.getHighEntropyValues) {
      const ua = await navigator.userAgentData.getHighEntropyValues([
        "platform", "platformVersion", "architecture", "bitness", "model", "uaFullVersion",
      ]);
      hints.platform = ua.platform;
      hints.platform_version = ua.platformVersion;
      hints.architecture = ua.architecture;
      hints.bitness = ua.bitness;
      hints.model = ua.model;
      hints.ua_full_version = ua.uaFullVersion;
    } else if (navigator.userAgentData) {
      hints.platform = navigator.userAgentData.platform;
      hints.mobile = navigator.userAgentData.mobile;
    }
  } catch (e) {
    /* ignore */
  }
  return hints;
}
